export const GET_DASHBOARD_HIGHCHART_DATA = "GET_DASHBOARD_HIGHCHART_DATA";
export const GET_DASHBOARD_DEVICE_DATA_REALTIME = "GET_DASHBOARD_DEVICE_DATA_REALTIME";
export const GET_DASHBOARD_DEVICE_DATA_REALTIME_TABLE = "GET_DASHBOARD_DEVICE_DATA_REALTIME_TABLE";
export const UPLOAD_OPERATION_GUIDANCE_MANUAL_FILE = "UPLOAD_OPERATION_GUIDANCE_MANUAL_FILE";
export const DELETE_OPERATION_GUIDANCE_MANUAL_FILE = "DELETE_OPERATION_GUIDANCE_MANUAL_FILE";